import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_CircleCheck } from 'hosman-material';
import { calculateAgencyFees, definePremium, agencyFeesRateLabel, displayedSalePrice } from '../../../../../utils/helpers/hosmanVars';

import { Card } from 'hosman-material';

const classicItems = [
  'Un agent immobilier local dédié tout au long de votre vente',
  'Des photos professionnelles (10), un plan 2D, et une visite virtuelle 3D',
  'Publication de votre annonce auprès de notre base acheteurs et + 40 portails immobiliers',
  "Votre espace en ligne où vous suivrez en temps réel votre projet de vente (visites, offres d'achats...)",
  "L'accès à notre réseau de partenaires notaires et l'accompagnement administratif jusqu'à la vente définitive"
]

const premiumItems = [
  'Un spécialiste Premium dédié tout au long de votre vente',
  'Des photos professionnelles (16), un plan 2D, et une visite virtuelle 3D',
  'Publication de votre annonce auprès de notre base acheteurs et + 40 portails immobiliers et Premium',
  "Votre espace en ligne où vous suivrez en temps réel votre projet de vente (visites, offres d'achats...)",
  "L'accès à notre réseau de partenaires notaires et l'accompagnement administratif jusqu'à la vente définitive"
]

const studioItems = [
  'Un agent immobilier local dédié tout au long de votre vente',
  'Des photos professionnelles (8) et un plan 2D',
  'Publication de votre annonce auprès de notre base acheteurs et + 40 portails immobiliers',
  "Votre espace en ligne où vous suivrez en temps réel votre projet de vente (visites, offres d'achats...)",
  "L'accès à notre réseau de partenaires notaires et l'accompagnement administratif jusqu'à la vente définitive"
]

const HosmanOffer = ({ sale }) => {
  const feesRegion = sale.region.name_raw;
  const parisRegion = feesRegion == 'Paris'
  const salePrice = displayedSalePrice(sale);
  const agencyFees = sale.mandate_signed ? sale.agency_fees : calculateAgencyFees(feesRegion, salePrice, false);

  const classicFees = salePrice < 150_000 ? salePrice * 0.06 : salePrice * 0.0578
  const premium = definePremium(parisRegion, salePrice)

  const sellerSavings = Math.floor(classicFees - agencyFees)

  return (
    <div className='flex flex-col gap-6 text-ih-indigo px-8' data-testid='HosmanOffer'>
      <Card>
        <div className='flex flex-col gap-10 py-5 md:py-10'>
          <div className='flex flex-col gap-4'>
            <p className='h2 text-center'>L'offre Hosman <span className='text-ih-blue'>pour vous </span></p>
          </div>
          <div className='mx-auto'>
            <div className='grid grid-cols-1 md:grid-cols-12 gap-10 md:divide-x-2 px-8'>
              <div className='md:col-span-7'>
                <div className='flex flex-col gap-4'>
                  <div className='flex flex-col md:flex-row gap-3'>
                    <p className='h3 text-center md:text-left'>Votre accompagnement Hosman</p>
                  </div>

                  {(premium ? premiumItems : sale.property.room_number > 1 ? classicItems : studioItems).map((item, index) => {
                    return (
                      <div key={index} className='flex items-center gap-3'>
                        <FontAwesomeIcon icon={S_CircleCheck} className='text-ih-green' size='lg' />
                        <p>{item}</p>
                      </div>
                    )
                  })}
                </div>
              </div>

              <div className='md:col-span-5 flex flex-col gap-6 text-center px-4'>
                <div className='flex flex-col gap-1'>
                  <p className='h2'>Nos honoraires{!sale.mandate_signed && ' *'}</p>
                  <p className='h1 text-ih-blue italic'>{agencyFeesRateLabel(feesRegion, salePrice) || `${agencyFees.toLocaleString('fr-FR')} €`}</p>
                </div>

                { sellerSavings > 0 &&
                  <>
                    <p className='font-semibold'>Votre net vendeur</p>
                    <div className='flex justify-center gap-4 align-bottom'>
                      <div className='flex flex-col gap-3 items-center'>
                        <p className='text-ih-blue'>{Math.floor(salePrice - agencyFees).toLocaleString('fr-FR')} €</p>
                        <div className='w-24 h-24 bg-ih-blue rounded-xl'></div>
                        <p>Hosman</p>
                      </div>
                      <div className='flex flex-col gap-3 items-center justify-end'>
                        <p className='text-ih-indigo-20'>{Math.floor(salePrice - classicFees).toLocaleString('fr-FR')} €</p>
                        <div className='w-24 h-20 bg-ih-indigo-20 rounded-xl'></div>
                        <p>Agence classique</p>
                      </div>
                    </div>

                    <p className='h3 w-3/4 mx-auto'>Avec Hosman, économisez <span className='text-ih-blue'>{sellerSavings.toLocaleString('fr-FR')} €</span> sur votre net vendeur</p>
                  </>
                }

                {!sale.mandate_signed && <p className='text-xs mt-auto self-start text-left'>* Dans le cadre d'un mandat exclusif</p>}
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default HosmanOffer;

// PropTypes
HosmanOffer.propTypes = {
  sale: PropTypes.object.isRequired
}
